import React, { PureComponent } from 'react';
import { gtm } from 'apps/gtm';

import { PageViewConsumer, propTypesOfPageViewContext } from './PageView';

class LoginEventSenderInternal extends PureComponent {
  static propTypes = propTypesOfPageViewContext;

  componentDidMount() {
    this.track();
  }

  componentDidUpdate() {
    this.track();
  }

  async track() {
    const { pageView, user } = this.props;

    const isJustLoggedIn = await pageView.isJustLoggedIn;
    if (isJustLoggedIn) {
      gtm.trigger('gtm:login', {
        userId: user.customerNum,
        method: undefined,
        hashedEmail: user.emailToken,
      });
    }
  }

  render = () => null;
}

const LoginEventSender = (props) => (
  <PageViewConsumer>
    {context => <LoginEventSenderInternal {...context} {...props} />}
  </PageViewConsumer>
);

export default LoginEventSender;
